@for (toast of toastService.toasts(); track toast) {
  <ngb-toast
    class="cursor-pointer p-2 m-2 mt-1"
    [class]="'bg-' + toast.type"
    [animation]="false"
    [autohide]="toast.delay === 0 ? false : true"
    [delay]="toast.delay || 5000"
    (click)="copyAndClose(toast)"
    (hidden)="remove(toast)"
  >
    <div class="row">
      <div class="col-2 d-flex align-items-center justify-content-center">
        <i
          class="fa-light fa-2xl text-light"
          [ngClass]="{
            'fa-circle-exclamation': toast.type === ToastType.Info,
            'fa-bolt': toast.type === ToastType.Danger,
            'fa-triangle-exclamation': toast.type === ToastType.Warning,
            'fa-circle-check': toast.type === ToastType.Success,
          }"
        ></i>
      </div>
      <div class="col-10">
        <h6 class="text-light">{{ toast.title }}</h6>
        <span class="text-light">{{ toast.message }}</span>
      </div>
    </div>
  </ngb-toast>
}
